<div class="login-background">
    <div class="login-form">
        <h1 class="h2 condensed">Bezig met inloggen als geselecteerde gebruiker...</h1>
        @if (errorMessage) {
            <div class="mb-3 pb-1 pt-1 error-background text-center">
                {{ errorMessage }}
            </div>
            <div class="login-buttons">
                <button mat-raised-button color="primary" routerLink="/{{ Routenames.login }}">
                    Terug naar inloggen
                </button>
            </div>
        } @else {
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
    </div>
</div>
